
import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false
  );

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      const mobileStatus = currentWidth < MOBILE_BREAKPOINT;
      setIsMobile(mobileStatus);
    };
    
    // Add event listener for resize with passive flag for performance
    window.addEventListener("resize", handleResize, { passive: true });
    
    // Initial check
    handleResize();
    
    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
}
